import React, { useEffect, useState } from 'react';
import LogoIcon from '../../Assets/obs_logo.png';
import './Loader.css';

const Loader = () => {
    const [phase, setPhase] = useState('enter');   // enter → hold → exit
    const [visible, setVisible] = useState(true);
    const [progress, setProgress] = useState(0);

    useEffect(() => {
        document.body.style.overflow = 'hidden';

        // Animate progress bar 0 → 100 over ~1.6s
        let start = null;
        const duration = 1600;
        const tick = (ts) => {
            if (!start) start = ts;
            const elapsed = ts - start;
            const pct = Math.min((elapsed / duration) * 100, 100);
            setProgress(pct);
            if (pct < 100) requestAnimationFrame(tick);
        };
        requestAnimationFrame(tick);

        // Begin exit transition
        const fadeTimer = setTimeout(() => setPhase('exit'), 1800);

        // Remove from DOM
        const removeTimer = setTimeout(() => {
            setVisible(false);
            document.body.style.overflow = '';
        }, 2400);

        return () => {
            clearTimeout(fadeTimer);
            clearTimeout(removeTimer);
            document.body.style.overflow = '';
        };
    }, []);

    if (!visible) return null;

    return (
        <div className={`obs-loader ${phase === 'exit' ? 'obs-loader--exit' : ''}`}>

            {/* Animated grid background */}
            <div className="obs-loader__grid" />

            {/* Floating orbs */}
            <div className="obs-loader__orb obs-loader__orb--1" />
            <div className="obs-loader__orb obs-loader__orb--2" />
            <div className="obs-loader__orb obs-loader__orb--3" />

            <div className="obs-loader__center">

                {/* Logo box */}
                <div className="obs-loader__logo-box">
                    <div className="obs-loader__logo-ring" />
                    <div className="obs-loader__logo-ring obs-loader__logo-ring--2" />
                    <img src={LogoIcon} alt="OBS" className="obs-loader__logo" />
                </div>

                {/* Brand name */}
                <div className="obs-loader__brand">
                    <span className="obs-loader__brand-main">Oriental Business</span>
                    <span className="obs-loader__brand-sub">Solutions</span>
                </div>

                {/* Dots indicator */}
                <div className="obs-loader__dots">
                    <span className="obs-loader__dot" style={{ '--i': 0 }} />
                    <span className="obs-loader__dot" style={{ '--i': 1 }} />
                    <span className="obs-loader__dot" style={{ '--i': 2 }} />
                    <span className="obs-loader__dot" style={{ '--i': 3 }} />
                    <span className="obs-loader__dot" style={{ '--i': 4 }} />
                </div>

                {/* Progress bar */}
                <div className="obs-loader__track">
                    <div
                        className="obs-loader__bar"
                        style={{ width: `${progress}%` }}
                    />
                </div>

                <p className="obs-loader__tagline">
                    Tax &amp; Business Experts
                </p>
            </div>
        </div>
    );
};

export default Loader;
